











import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {SocleClient} from "@/modules/Socle";
import moment from "moment";
import _ from "lodash";

interface SocleBundle {
    validationDeadline: string;
    approvalDeadline: string;
    budgets: [{
        validationDeadline: string;
    }];
}

@Component({ components: { } })
export default class ValidationDeadline extends Vue {
    @Prop() public bundle!: SocleBundle;
    @Prop({default: true}) public approver!: boolean;
    @Prop() public config!: SocleClient;

    private approvalDeadline: any = null;
    private firstBudget: any = null;

    public static getNeededFields(): string[] {
        return [
            "bundle.approvalDeadline",
            "bundle.budgets.validationDeadline",
        ];
    }

    public mounted(): void {
        if (
            this.bundle &&
            this.bundle.budgets
        ) {
            this.firstBudget = _.first(this.bundle.budgets);
            this.approvalDeadline = moment(this.bundle.approvalDeadline);
        }
    }
}
